import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import Select from 'components/Select';
import {arrowRenderer} from 'components/Paginator';
import {PaginatorButton} from 'components/Paginator/components';

import {CursorPaginationForStore} from 'utils/pagination';

import './styles.css';

const PAGE_SIZE_OPTIONS = [
  {label: 10, value: 10},
  {label: 20, value: 20},
  {label: 50, value: 50}
];

interface PaginatorProps {
  pagination: CursorPaginationForStore;
  onNextPage: ({pageSize}: {pageSize: number}) => void;
  onPrevPage: ({pageSize}: {pageSize: number}) => void;
  onPageChange: (
    {pageSize, cursor}: {pageSize: number; cursor: number | null}
  ) => void;
  ActionsComponent?: React.ComponentType;
}

class CursorPaginator extends React.Component<PaginatorProps> {
  onNextPage = () => {
    const {pagination: {pageSize}} = this.props;

    this.props.onNextPage({
      pageSize: Math.abs(pageSize)
    });
  };

  onPrevPage = () => {
    const {pagination: {pageSize}} = this.props;

    this.props.onPrevPage({
      pageSize: -Math.abs(pageSize)
    });
  };

  onPageSizeChange = option => {
    this.props.onPageChange({
      pageSize: option.value,
      cursor: null
    });
  };

  onDefaultClick = () => {
    const {pagination: {pageSize}} = this.props;

    this.props.onPageChange({
      pageSize: Math.abs(pageSize),
      cursor: null
    });
  };

  render() {
    const {pagination: {pageSize, hasPrevious, hasNext}} = this.props;

    const PAGE_SIZE_OPTION = {
      label: Math.abs(pageSize),
      value: pageSize
    };

    return (
      <div className="CursorPaginator colab-row-space-between colab-centered-v">
        <div className="CursorPaginator__spacer" />

        <div className="CursorPaginator__body colab-row-space-between colab-centered-v">
          {hasPrevious && (
            <PaginatorButton
              direction={PaginatorButton.PREVIOUS}
              onClick={this.onPrevPage}
            />
          )}
          {!hasPrevious && <div className="CursorPaginator__spacer" />}

          <Button
            className="CursorPaginator__body__defaultButton"
            blue
            onClick={this.onDefaultClick}>
            Today
          </Button>

          {hasNext && (
            <PaginatorButton
              direction={PaginatorButton.NEXT}
              onClick={this.onNextPage}
            />
          )}
          {!hasNext && <div className="CursorPaginator__spacer" />}
        </div>
        <div className="CursorPaginator__pageSizes colab-row-space-between colab-centered-v">
          <p className="CursorPaginator__pageSizes__view colab-bold">View</p>
          <Select
            className="CursorPaginator__pageSizes__select"
            onChange={this.onPageSizeChange}
            value={PAGE_SIZE_OPTION}
            options={PAGE_SIZE_OPTIONS}
            clearable={false}
            arrowRenderer={arrowRenderer}
            menuPosition={Select.TOP}
          />
        </div>
      </div>
    );
  }
}

export default CursorPaginator;
